import React from "react";

function PumaTermsAndConditions() {
  return (
    <main className="min-h-screen bg-gray-50">
      <section className="py-16 text-white bg-fordBlue">
        <div className="w-full max-w-5xl px-4 mx-auto">
          <div className="mb-3 text-xs tracking-[0.12em] uppercase text-white/70">
            Документ
          </div>

          <h1 className="text-3xl font-semibold leading-tight md:text-4xl">
            ОФИЦИАЛНИ ПРАВИЛА ЗА УЧАСТИЕ В ИГРАТА
          </h1>

          <p className="mt-4 text-base md:text-lg text-white/85">
            „СТАРТИРАЙ ПРОЛЕТТА С PUMA GEN-E“
          </p>
        </div>
      </section>

      <section className="py-12 pb-20">
        <div className="w-full max-w-5xl px-4 mx-auto">
          <div className="bg-white rounded-2xl shadow-sm ring-1 ring-black/5 p-6 md:p-10 text-[15px] leading-relaxed text-black/85">
            <Section title="РАЗДЕЛ I. ОРГАНИЗАТОР НА ИГРАТА">
              <p>
                <strong>1.</strong> Организатор на играта e Мото-Пфое с адрес
                гр. София, бул. Сливница 444 (наричан по-долу „Организатор“).
              </p>
            </Section>

            <Section title="РАЗДЕЛ II. ТЕРИТОРИЯ И ПРОДЪЛЖИТЕЛНОСТ НА ИГРАТА">
              <p>
                <strong>2.</strong> Играта се провежда в периода от 02.03.2026
                г. до 12.04.2026 г. на територията на гр. София, Република
                България.
              </p>
            </Section>

            <Section title="РАЗДЕЛ III. ПРАВО НА УЧАСТИЕ">
              <p>
                <strong>3.</strong> Участник в Играта може да бъде всяко лице,
                навършило 18 години към датата на стартирането ѝ, което живее на
                територията на Република България, с изключение на служителите
                на Мото-Пфое, агенциите, които работят по проекта, както и
                членове на техните семейства (деца, съпрузи).
              </p>
              <p>
                <strong>4.</strong> Участниците в Играта са длъжни да спазват
                условията и разпоредбите на настоящите официални правила.
              </p>
              <p>
                <strong>5.</strong> Участието в Играта не е обвързано с покупка
                на продукти.
              </p>
            </Section>

            <Section title="РАЗДЕЛ IV. МЕХАНИЗЪМ НА ИГРАТА">
              <p>
                <strong>6.</strong> Играта се провежда на „стената“ на Facebook
                страницата на Ford Bulgaria:
              </p>
              <p>
                <a
                  href="https://www.facebook.com/FordBG/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                >
                  https://www.facebook.com/FordBG/
                </a>
              </p>
              <p>
                <strong>7.</strong> Участниците трябва да последват страницата
                на Ford Bulgaria във Facebook, да се снимат с Ford Puma Gen-E,
                изложен в магазин Техномаркет на бул. „Цариградско шосе“ 92 в
                периода 02.03.2026 г. - 12.04.2026 г. на територията на гр.
                София, и да споделят снимката си под публикацията за играта във
                Facebook.
              </p>
              <p>
                <strong>8.</strong> Всички лица, включили се в Играта, ще
                участват в томбола за 3 награди:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>1-ва награда - УИКЕНД ТЕСТ-ДРАЙВ С PUMA GEN-E;</li>
                <li>2-ра награда - 1 бр. раница Ford;</li>
                <li>3-та награда - 1 бр. бутилка Ford.</li>
              </ul>
              <p>
                Всеки един участник има право да участва само по един път, без
                да противоречи на условията на Играта и на законодателството на
                Република България.
              </p>
              <p>
                <strong>9.</strong> С участието си в Играта всеки един участник
                декларира, че е запознат с официалните правила на Играта.
                Участниците дават изричното си доброволно съгласие, тяхната
                публикация да бъде налична на „стената“ на Ford Bulgaria във
                Facebook за неограничен период от време.
              </p>
              <p>Забранено е публикациите да съдържат:</p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>
                  обидни, клеветнически, злепоставящи, опозоряващи елементи или
                  елементи, които са в състояние да засегнат негативно доброто
                  име, репутацията, правата и законовите интереси на трето лице,
                  включително на Организатора и/или негови служители;
                </li>
                <li>
                  споменаване на тютюневи изделия, алкохолни напитки, оръжия,
                  наркотици, лекарства;
                </li>
                <li>
                  директно или индиректно нецензурни, дискриминационни,
                  ксенофобски, развратни, насилствени, военно-пропагандни,
                  религиозно-пропагандни, политическо-пропагандни елементи,
                  както и всякакъв друг вид елементи, които биха могли да влязат
                  в противоречие със закона, морала и добрите нрави, етичните
                  правила на Националния съвет за саморегулация (НСС), както и
                  комуникационните принципи и политики на Организатора;
                </li>
                <li>
                  съдържание, което е или може по преценка на Организатора да
                  представлява някакъв вид тайна и/или информация, защитена със
                  закон, чието използване под каквато и да е форма не може да
                  стане, без да са изпълнени предвидените за това законови
                  изисквания;
                </li>
                <li>
                  съдържание, което по начина на представянето му може нормално
                  и разумно да се приеме като явна или скрита реклама и/или
                  продуктово позициониране на продукти, различни от тези на
                  Организатора.
                </li>
              </ul>
              <p>Нарушение на правилата изрично включва действия за:</p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>
                  повече от едно участие от едно лице и от един профил във
                  Facebook;
                </li>
                <li>
                  използване на повече от един Facebook профил от едно и също
                  лице за участие в Играта;
                </li>
                <li>
                  използване на техники и/или технологии, които изменят елемента
                  на лично и индивидуално участие на съответното физическо лице
                  в Играта;
                </li>
                <li>
                  всяко друго действие, което променя механизма за участие в
                  Играта или увеличава шансовете за печалба на някой участник
                  извън описания механизъм в настоящите правила.
                </li>
              </ul>
              <p>
                <strong>10.</strong> Организаторът запазва правото си да
                дисквалифицира всеки участник и/или да скрие всяко съдържание,
                което според Организатора нарушава и/или не отговаря на
                условията на Играта и/или действащото българско законодателство,
                без да дължи обяснение за това.
              </p>
              <p>
                <strong>11.</strong> Ако в резултат на участието в Играта бъдат
                засегнати права и законови интереси на трети лица от участник в
                Играта, този участник носи цялата отговорност за всички
                причинени им преки и непосредствени вреди и пропуснати ползи.
              </p>
              <p>
                <strong>12.</strong> Организаторът си запазва право да не води
                никаква комуникация или дискусия с участници във връзка със
                скриването на техните коментари/снимки.
              </p>
            </Section>

            <Section title="РАЗДЕЛ V. НАГРАДИ, ТЕГЛЕНЕ И ОБЯВЯВАНЕ НА ПЕЧЕЛИВШИЯ">
              <p>
                <strong>13.</strong> Наградите за победителите са:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>1-ва награда - УИКЕНД ТЕСТ-ДРАЙВ С PUMA GEN-E;</li>
                <li>2-ра награда - 1 бр. раница Ford;</li>
                <li>3-та награда - 1 бр. бутилка Ford.</li>
              </ul>
              <p>
                <strong>14.</strong> Победителите имат право да получат
                наградите до 1 месец след обявяването им.
              </p>
              <p>
                <strong>15.</strong> Наградата се получава след удостоверяване
                на самоличността и попълване на декларация от страна на
                спечелилия участник, в която той посочва трите си имена, ЕГН и
                данни за Facebook профила. С подписването ѝ печелившият участник
                се съгласява, че е получил наградата си.
              </p>
              <p>
                <strong>16.</strong> На 14.04.2026 г. ще бъдат изтеглени трима
                печеливши участници на случаен принцип в присъствието на комисия
                от трима служители на Организатора чрез електронната платформа:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>
                  <a
                    href="https://www.random.org/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                  >
                    https://www.random.org/
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.wask.co"
                    target="_blank"
                    rel="noreferrer"
                    className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                  >
                    https://www.wask.co
                  </a>
                </li>
              </ul>
              <p>
                Имената на печелившите (име на Facebook профила) ще бъдат
                обявени на Facebook страницата на Ford Bulgaria:
              </p>
              <p>
                <a
                  href="https://www.facebook.com/FordBG/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                >
                  https://www.facebook.com/FordBG/
                </a>
              </p>
              <p>След изтегляне на победителите комисията съставя протокол.</p>
              <p>
                <strong>17.</strong> След като участникът види името си в
                профила на страницата, че е спечелил наградата, той следва да се
                свърже с Организатора чрез лично съобщение, като посочи три
                имена и телефон за връзка.
              </p>
              <p>
                <strong>18.</strong> В случай че победителят не може да приеме
                наградата или не осъществи контакт с Организатора в рамките на 1
                месец след уведомяването за спечелване на наградата, спечелилият
                участник губи правото си да получи наградата.
              </p>
              <p>
                <strong>19.</strong> Не се допуска замяна на наградата с нейната
                парична равностойност или предмет.
              </p>
            </Section>

            <Section title="РАЗДЕЛ VI. ОГРАНИЧАВАНЕ НА ОТГОВОРНОСТТА НА ОРГАНИЗАТОРА">
              <p>
                <strong>20.</strong> Организаторът не носи отговорност и не
                дължи компенсация на спечелилия участник, ако същият не се е
                свързал с Организатора в срока по т. 18, по начина посочен в т.
                17 и/или не е отишъл да получи наградата.
              </p>
              <p>
                <strong>21.</strong> Организаторът не поема отговорност или
                задължения за:
              </p>
              <ul className="pl-6 mt-2 space-y-2 list-disc">
                <li>
                  загуба на данни, причинена от хакерски атаки или друго
                  неправомерно вмешателство в нормалното функциониране на
                  Facebook страницата Ford Bulgaria;
                </li>
                <li>
                  повреда на комуникационната връзка, независимо от причината,
                  по отношение на оборудване, системи, мрежи, линии, сателити,
                  сървъри, компютри или доставчици.
                </li>
              </ul>
              <p>
                <strong>22.</strong> Организаторът не се задължава да води
                кореспонденция с участниците за непечеливши претенции за
                получаване на награда, както и след изтичане на срока на Играта
                или по други подобни поводи.
              </p>
              <p>
                <strong>23.</strong> Организаторът не носи отговорност в случаи
                на невъзможност за участие в Играта поради настъпване на
                обстоятелство извън неговия контрол - случаи на непреодолима
                сила, случайни събития, проблеми в глобалната мрежа на интернет,
                проблеми в социалната мрежа Facebook, предоставяните от трети
                лица услуги извън контрола на Организатора.
              </p>
              <p>
                <strong>23.1.</strong> С участието в Играта победителят поема
                пълната имуществена отговорност за вреди, настъпили в следствие
                управление на автомобила.
              </p>
            </Section>

            <Section title="РАЗДЕЛ VII. ПРЕКРАТЯВАНЕ НА ИГРАТА">
              <p>
                <strong>24.</strong> Краят на Играта е 12.04.2026 г.
              </p>
              <p>
                Преди това Организаторът има право да прекрати Играта по всяко
                време, обявявайки това на:
              </p>
              <p>
                <a
                  href="https://www.facebook.com/FordBG/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                >
                  https://www.facebook.com/FordBG/
                </a>
              </p>
              <p>
                включително и в случай, че настъпят масови злоупотреби,
                нарушаване на правилата или форсмажорни обстоятелства. В тези
                случаи на участниците не се дължи компенсация за участието им в
                Играта.
              </p>
              <p>
                Организаторът няма да носи никаква отговорност за понесени
                загуби или пропуснати от участниците ползи, резултат от такова
                прекратяване на Играта.
              </p>
            </Section>

            <Section title="РАЗДЕЛ VIII. ЗАЩИТА НА ЛИЧНИТЕ ДАННИ">
              <p>
                <strong>25.</strong> Мото-Пфое е регистрирано като администратор
                на лични данни съгласно Закона за защита на личните данни.
              </p>
              <p>
                <strong>26.</strong> Публикувайки коментар за участие в Играта,
                всеки участник дава съгласието си и доброволно предоставя на
                Мото-Пфое личните си данни (име, фамилия и данни, които са
                публично достъпни в социалния профил на участника), с цел
                участие в тази игра, установяване на контакт с печелившите и
                получаване на награда.
              </p>
              <p>
                <strong>27.</strong> По-специално, участниците дават съгласието
                си Организаторът или оторизирани от него лица да ги търсят на
                предоставен от тях социален профил за контакт по време и в
                период от 3 (три) месеца след края на играта във връзка с нея.
                След изтичането на срока събраните лични данни следва да бъдат
                заличени, като за това бъде съставен протокол.
              </p>
              <p>
                <strong>28.</strong> Предоставените от участниците лични данни
                (име и фамилия) ще бъдат използвани единствено и само във връзка
                с настоящата Игра.
              </p>
              <p>
                <strong>29.</strong> Спечелилите награда участници се
                съгласяват, че техните имена (името на Facebook профила) ще
                бъдат публикувани на Facebook страницата на Ford Bulgaria:
              </p>
              <p>
                <a
                  href="https://www.facebook.com/FordBG/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                >
                  https://www.facebook.com/FordBG/
                </a>
              </p>
              <p>
                <strong>30.</strong> Всеки участник има право по всяко време да
                поиска от Организатора да коригира или заличи негови/нейните
                лични данни. За тази цел участникът изпраща лично съобщение в
                Facebook или на електронната поща на Организатора:
                <a
                  href="mailto:ford@motopfohe.bg"
                  className="ml-1 text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                >
                  ford@motopfohe.bg
                </a>
                .
              </p>
              <p>
                <strong>31.</strong> Организаторът на Играта съхранява личните
                данни само за срока, необходим за провеждането на играта, като
                отчита необходимостта от позоваване на данните в случай на
                въпроси или сигнали от участници в Играта, както и давностните
                срокове в действащото данъчно законодателство.
              </p>
            </Section>

            <Section title="РАЗДЕЛ IX. ДРУГИ">
              <p>
                <strong>32.</strong> Играта не е организирана, спонсорирана или
                по друг начин подкрепена от Facebook.
              </p>
              <p>
                <strong>33.</strong> Правилата са публикувани и ще останат
                достъпни за целия период на Играта на:
                <a
                  href="https://www.facebook.com/FordBG/"
                  target="_blank"
                  rel="noreferrer"
                  className="ml-1 text-[#0b1f33] underline underline-offset-4 hover:opacity-80"
                >
                  https://www.facebook.com/FordBG/
                </a>
                .
              </p>
              <p>
                <strong>34.</strong> Организаторът си запазва правото да допълва
                или променя Правилата по всяко време. В случай че участникът не
                е съгласен с Правилата или с техни промени, същият следва да не
                предприема действия за участие, съответно да прекрати участието
                си в Играта.
              </p>
              <p>
                <strong>35.</strong> За всички неуредени въпроси в тези Правила
                се прилага действащото българско законодателство.
              </p>
              <p>
                С участието си в Играта участниците се съгласяват и се
                задължават да спазват настоящите Официални правила.
              </p>
            </Section>
          </div>
        </div>
      </section>
    </main>
  );
}

function Section({ title, children }) {
  return (
    <div className="mb-12">
      <h2 className="text-lg md:text-xl font-semibold text-[#0b1f33] mb-5">
        {title}
      </h2>
      <div className="grid gap-3.5">{children}</div>
    </div>
  );
}

export default PumaTermsAndConditions;
